/* Carrousel glissant générique : flèches, points, et respect du clavier.
   La piste défile avec scroll-snap, on ne fait que la piloter. */
(function () {
  function brancher(car) {
    if (car.dataset.mcPret === '1') return;
    car.dataset.mcPret = '1';
    var piste = car.querySelector('.mc-car__piste');
    if (!piste) return;
    var items = Array.prototype.slice.call(piste.children);
    var zonePoints = car.querySelector('[data-mc-car-points]');
    var prec = car.querySelector('[data-mc-car-prec]');
    var suiv = car.querySelector('[data-mc-car-suiv]');

    // Le pas réel inclut l'espace entre les cartes : sans ça le calcul dérive
    // et les points ne suivaient plus les flèches.
    function pas() {
      if (!items.length) return 1;
      if (items.length > 1) {
        var d = items[1].offsetLeft - items[0].offsetLeft;
        if (d > 0) return d;
      }
      return items[0].offsetWidth || 1;
    }
    function parEcran() {
      return Math.max(1, Math.round(piste.clientWidth / pas()));
    }
    function pages() { return Math.max(1, Math.ceil(items.length / parEcran())); }
    function pageCourante() {
      var bloc = pas() * parEcran();
      if (!bloc) return 0;
      var max = pages() - 1;
      return Math.min(max, Math.max(0, Math.round(piste.scrollLeft / bloc)));
    }
    function construirePoints() {
      if (!zonePoints) return;
      zonePoints.innerHTML = '';
      var n = pages();
      if (n < 2) { car.classList.add('mc-car--solo'); return; }
      car.classList.remove('mc-car--solo');
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'mc-car__pt' + (i === pageCourante() ? ' is-on' : '');
        b.setAttribute('aria-label', 'Page ' + (i + 1) + ' sur ' + n);
        (function (j) { b.addEventListener('click', function () { aller(j); }); })(i);
        zonePoints.appendChild(b);
      }
    }
    function majPoints(force) {
      if (!zonePoints) return;
      var c = (typeof force === 'number') ? force : pageCourante();
      Array.prototype.forEach.call(zonePoints.children, function (b, i) {
        b.classList.toggle('is-on', i === c);
      });
    }
    function aller(i) {
      if (!items[0]) return;
      var n = pages();
      i = Math.min(n - 1, Math.max(0, i));
      piste.scrollTo({ left: i * pas() * parEcran(), behavior: 'smooth' });
      majPoints(i);           // on met les points à jour tout de suite
    }

    if (prec) prec.addEventListener('click', function () { aller(Math.max(0, pageCourante() - 1)); });
    if (suiv) suiv.addEventListener('click', function () { aller(Math.min(pages() - 1, pageCourante() + 1)); });
    // requestAnimationFrame passe un horodatage au rappel : sans la fonction
    // anonyme, majPoints le prenait pour un numéro de page et éteignait tous les points.
    piste.addEventListener('scroll', function () {
      window.requestAnimationFrame(function () { majPoints(); });
    }, { passive: true });
    window.addEventListener('resize', construirePoints);
    construirePoints();

    // Défilement automatique, comme sur le site actuel.
    var auto = parseInt(car.getAttribute('data-mc-auto'), 10);
    if (auto > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var minuteur = null, enPause = false;
      function tic() {
        // une vidéo dont la cliente a activé le son garde la main
        if (enPause || document.hidden || car.querySelector('.is-son')) return;
        var n = pages();
        if (n < 2) return;
        var c = pageCourante();
        aller(c + 1 >= n ? 0 : c + 1);
      }
      function demarrer() { if (!minuteur) minuteur = setInterval(tic, auto); }
      function arreter() { if (minuteur) { clearInterval(minuteur); minuteur = null; } }
      car.addEventListener('mouseenter', function () { enPause = true; });
      car.addEventListener('mouseleave', function () { enPause = false; });
      car.addEventListener('focusin', function () { enPause = true; });
      car.addEventListener('focusout', function () { enPause = false; });
      piste.addEventListener('touchstart', function () { enPause = true; }, { passive: true });
      piste.addEventListener('touchend', function () { setTimeout(function () { enPause = false; }, 4000); }, { passive: true });
      // on ne tourne que si le carrousel est à l'écran
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { e.isIntersecting ? demarrer() : arreter(); });
        }, { threshold: 0.2 }).observe(car);
      } else { demarrer(); }
    }
  }
  function init(r) { (r || document).querySelectorAll('[data-mc-car]').forEach(brancher); }
  document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  init();
})();
